import { render, staticRenderFns } from "./CardElementDeleteAction.vue?vue&type=template&id=1a066b34"
import script from "./CardElementDeleteAction.vue?vue&type=script&lang=js"
export * from "./CardElementDeleteAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports